export default function () {
    function build(entity) {
        if (!entity) throw Error('No supplied entity.');
        return {
            ...entity,
            dancer_route: dancerRoute(entity),
            dancer_thumb_url: dancerThumbUrl(entity),
            dancer_image_url: dancerImageUrl(entity),
        };
    }

    async function get(dancerSlug) {
        let dancer = null,
            error = null;
        try {
            const {data} = await useApi('videos').get('dancers/' + dancerSlug);
            dancer = build(data.dancer);
        } catch (e) {
            error = useApiError(e);
        }
        return {dancer, error};
    }

    function dancerRoute(entity) {
        if (!entity.dancer_slug) return undefined;
        return {
            name: 'dancers-dancerSlug',
            params: {
                dancerSlug: entity.dancer_slug,
            },
        };
    }

    function dancerThumbUrl(entity) {
        if (!entity.dancer_video_youtube_id) return null;
        return `https://img.youtube.com/vi/${entity.dancer_video_youtube_id}/mqdefault.jpg`;
    }

    function dancerImageUrl(entity) {
        if (!entity.dancer_video_youtube_id) return null;
        return `https://img.youtube.com/vi/${entity.dancer_video_youtube_id}/maxresdefault.jpg`;
    }

    return {build, get};
}
